//import custom component
import CardGrid from "../CardGrid";

function CardChart(props) {
  const { payload, classes, datastoryStateTitleClass } = props;
  const {
    bgIMG,
    isSelected,
    title,
    moreOptions,
    lastAccessedOptions,
    tag,
    onClick,
  } = payload;
  const { flag, icon: moreOptionsIcon } = moreOptions;
  const {
    flag: isLastAccessedOptionPresent,
    icon: lastAccessedOptionsIcon,
    data: lastAccessedOptionsData,
  } = lastAccessedOptions;
  const { updatedSince } = lastAccessedOptionsData;
  const isMoreOptionsIconPresent = flag;
  const DimensionsCount =
    props.actualPayload?.chartItemPayload?.chartObjectUI?.dimensionsList
      ?.length;
  const MetricsCount =
    props.actualPayload?.chartItemPayload?.chartObjectUI?.metricsList?.length;
  const chartTypeName =
    props.actualPayload?.chartItemPayload?.metadata?.chartType;

  const extraStyles = {
    cardImgContainerStyles: {
      backgroundImage: `url(${bgIMG})`,
      height: "100%",
      width: "100%",
      backgroundSize: "contain",
    },
    cardImgWithIconContainerStyles: {
      backgroundImage: `url(${bgIMG})`,
      height: "40%",
      width: "40%",
      backgroundPosition: "center",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    },
    cardTitleContainerStyles: {
      padding: `${
        isMoreOptionsIconPresent ? "10px 6px 3px 8px" : "10px 10px 3px 8px"
      }`,
    },
    cardSubtitleContainerStyles: {
      padding: "3px 8px 8px",
    },
    cardTitleStyles: {
      width: `${isMoreOptionsIconPresent ? "145px" : "100%"}`,
    },
  };
  const {
    cardImgContainerStyles,
    cardTitleContainerStyles,
    cardSubtitleContainerStyles,
    cardTitleStyles,
    cardImgWithIconContainerStyles,
  } = extraStyles;

  // Defining required event handlers
  const handleClick = (e) => onClick(e, props);

  //Defining static variables
  let cardBackground;

  // switch case which is checking witch component will mount
  switch (tag) {
    case "chart":
      cardBackground = (
        <div
          className={`${datastoryStateTitleClass}-GA card-image-container`}
          style={cardImgContainerStyles}
        ></div>
      );
      break;
    case "chartWithIcon":
      cardBackground = (
        <div
          className={`${datastoryStateTitleClass}-GA card-image-container`}
          style={cardImgWithIconContainerStyles}
        ></div>
      );
      break;
    case "gridChart":
      const { gridData } = props;
      cardBackground = (
        <div className={`${datastoryStateTitleClass}-GA card-image-container`}>
          <CardGrid gridData={gridData} width={180} height={92} />
        </div>
      );
      break;
    default:
      cardBackground = <></>;
      console.log("somethings went wrong");
      break;
  }

  return (
    <>
      <article
        className={`${classes.card} ${datastoryStateTitleClass}-GA`}
        onClick={handleClick}
      >
        <div
          className={`${datastoryStateTitleClass}-GA card-image-body-container`}
        >
          {isLastAccessedOptionPresent && updatedSince && (
            <div className="last-accessed-option-icon-container">
              <span className={lastAccessedOptionsIcon.className}>
                {lastAccessedOptionsIcon.value}
              </span>
              <span>{updatedSince}</span>
            </div>
          )}
          {cardBackground}
          {(chartTypeName || isSelected) && (
            <div className="card-overlay-container">
              {chartTypeName && (
                <div className="card-chartName-container">
                  <span>{chartTypeName}</span>
                </div>
              )}
              {isSelected && (
                <div className="card-tick-icon-container">
                  <span className="material-icons">check_circle</span>
                </div>
              )}
            </div>
          )}
        </div>
        <div
          className={`${datastoryStateTitleClass}-GA card-title-container`}
          style={cardTitleContainerStyles}
        >
          <div
            className={`${datastoryStateTitleClass}-GA card-title`}
            style={cardTitleStyles}
            title={title}
          >
            <span> {title} </span>
          </div>
          {flag && (
            <div className="more-option-icon-container">
              <span className={moreOptionsIcon.className}>
                {moreOptionsIcon.value}
              </span>
            </div>
          )}
        </div>
        <div
          className={`${datastoryStateTitleClass}-GA card-subtitle-container`}
          style={cardSubtitleContainerStyles}
        >
          <div className={`${datastoryStateTitleClass}-GA card-subtitle`}>
            {DimensionsCount} Dim | {MetricsCount} Metrics
          </div>
        </div>
      </article>
    </>
  );
}

export default CardChart;
